import React from 'react'
import { TextField, Button } from '@shopify/polaris'
const ResourcePickerInputComponent = (props) => {
  /**
   * Trigger resource picker to open upload modal
   * @param e
   */
  const handleButtonClick = async (e) => {
    const selection = await shopify.resourcePicker({
      type: props.dataType,
      multiple: false,
      filter: {
        variants: props.dataType === 'product',
        hidden: false
      }
    })

    if (selection && selection.length > 0) {
      if (props.onChange) props.onChange(props.dataType, selection[0])
    }
  }

  const connectedRight = <div>
    <Button onClick={handleButtonClick}>{props.buttonLabel || 'Browse'}</Button>
  </div>

  return (
    <TextField
      {...props}
      connectedRight={connectedRight}
      readOnly
    />
  )
}

export default ResourcePickerInputComponent
